import React, { useState } from 'react';
import { Modal } from './ui/Modal';
import { LeafIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-gray-900 text-gray-400 py-12 text-sm" data-id="element-1">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-2">
          {/* Brand */}
          <div className="flex items-center justify-center gap-2 mb-4 text-gray-300" data-id="element-3">
            <LeafIcon className="w-4 h-4 text-[#4A6741]" data-id="element-4" />
            <span className="font-semibold tracking-wide" data-id="element-5">
              Método Natural Care
            </span>
          </div>

          {/* Copyright */}
          <p className="text-center mb-4" data-id="element-6">
            &copy; {new Date().getFullYear()} Método Natural Care. Todos los
            derechos reservados.
          </p>

          {/* Legal Links */}
          <div className="flex items-center justify-center gap-4 mb-6" data-id="element-7">
            <button onClick={() => setActiveModal('privacy')} className="underline underline-offset-2 decoration-gray-600 hover:text-[#8CB485] hover:decoration-[#8CB485] transition-colors focus:outline-none focus:ring-1 focus:ring-[#4A6741] rounded px-1" data-id="element-8">
              Política de Privacidad
            </button>
            <span className="text-gray-600" aria-hidden="true" data-id="element-9">
              •
            </span>
            <button onClick={() => setActiveModal('terms')} className="underline underline-offset-2 decoration-gray-600 hover:text-[#8CB485] hover:decoration-[#8CB485] transition-colors focus:outline-none focus:ring-1 focus:ring-[#4A6741] rounded px-1" data-id="element-10">
              Términos y Condiciones
            </button>
          </div>

          {/* Disclaimer */}
          <p className="max-w-md mx-auto text-xs text-center opacity-50 leading-relaxed" data-id="element-11">
            Descargo de responsabilidad: Este producto no sustituye el consejo
            médico profesional. Los resultados pueden variar según cada persona.
          </p>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-12">
        <div className="space-y-6" data-id="element-13">
          <p className="text-gray-500 text-xs" data-id="element-14">
            Última actualización: Enero 2026
          </p>

          <section data-id="element-15">
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-16">
              1. Información que Recopilamos
            </h3>
            <p data-id="element-17">
              Al realizar tu compra, recopilamos únicamente la información
              necesaria para procesar tu pedido y entregarte el producto
              digital:
            </p>
            <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-18">
              <li data-id="element-19">Nombre completo</li>
              <li data-id="element-20">Dirección de correo electrónico</li>
              <li data-id="element-21">
                Información de pago (procesada de forma segura por terceros)
              </li>
            </ul>
          </section>

          <section data-id="element-22">
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-23">
              2. Uso de la Información
            </h3>
            <p data-id="element-24">Tu información personal se utiliza exclusivamente para:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-25">
              <li data-id="element-26">Procesar y entregar tu compra del eBook</li>
              <li data-id="element-27">Enviarte el enlace de descarga a tu correo electrónico</li>
              <li data-id="element-28">Comunicarnos contigo en caso de problemas con tu pedido</li>
            </ul>
          </section>

          <section data-id="element-29">
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-30">
              3. Protección de Datos
            </h3>
            <p data-id="element-31">
              Implementamos medidas de seguridad técnicas y organizativas para
              proteger tu información personal contra acceso no autorizado,
              alteración, divulgación o destrucción. Los pagos son procesados a
              través de plataformas seguras con cifrado SSL.
            </p>
          </section>

          <section data-id="element-32">
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-33">
              4. Compartir Información
            </h3>
            <p data-id="element-34">
              No vendemos, comercializamos ni transferimos tu información
              personal a terceros. La única excepción son los proveedores de
              servicios de pago necesarios para procesar tu transacción.
            </p>
          </section>

          <section data-id="element-35">
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-36">5. Cookies</h3>
            <p data-id="element-37">
              Este sitio puede utilizar cookies para mejorar la experiencia del
              usuario y analizar el tráfico del sitio web. Puedes configurar tu
              navegador para rechazar cookies, aunque esto podría afectar la
              funcionalidad del sitio.
            </p>
          </section>

          <section data-id="element-38">
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-39">6. Tus Derechos</h3>
            <p data-id="element-40">
              Tienes derecho a acceder, rectificar o eliminar tus datos
              personales en cualquier momento. Para ejercer estos derechos,
              puedes comunicarte con nosotros a través de los canales indicados
              en tu correo de confirmación de compra.
            </p>
          </section>

          <section data-id="element-41">
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-42">
              7. Cambios en esta Política
            </h3>
            <p data-id="element-43">
              Nos reservamos el derecho de actualizar esta política de
              privacidad en cualquier momento. Los cambios serán publicados en
              esta misma página con la fecha de actualización correspondiente.
            </p>
          </section>
        </div>
      </Modal>

      {/* Terms & Conditions Modal */}
      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-44">
        <div className="space-y-6" data-id="element-45">
          <p className="text-gray-500 text-xs" data-id="element-46">
            Última actualización: Enero 2026
          </p>

          <section data-id="element-47">
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-48">
              1. Producto Digital
            </h3>
            <p data-id="element-49">
              El producto "Cosmética Natural y Artesanal en Casa — Método
              Natural Care" es un libro digital (eBook) en formato PDF. Al
              completar tu compra, recibirás acceso inmediato al archivo a
              través de tu correo electrónico.
            </p>
          </section>

          <section data-id="element-50">
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-51">2. Uso Personal</h3>
            <p data-id="element-52">
              El eBook es para uso personal e individual. Queda prohibida la
              reproducción, distribución, modificación o reventa total o parcial
              del contenido sin autorización expresa por escrito.
            </p>
          </section>

          <section data-id="element-53">
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-54">
              3. Propiedad Intelectual
            </h3>
            <p data-id="element-55">
              Todo el contenido del eBook, incluyendo textos, fórmulas,
              imágenes, diseños y plantillas, está protegido por derechos de
              autor. La compra otorga una licencia de uso personal, no la
              transferencia de propiedad intelectual.
            </p>
          </section>

          <section data-id="element-56">
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-57">
              4. Descargo de Responsabilidad
            </h3>
            <p data-id="element-58">
              El contenido de este eBook es de carácter educativo e informativo.
              No sustituye el consejo médico, dermatológico o profesional. El
              usuario es responsable de:
            </p>
            <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-59">
              <li data-id="element-60">
                Realizar pruebas de parche antes de usar cualquier producto
                elaborado
              </li>
              <li data-id="element-61">Verificar posibles alergias a los ingredientes utilizados</li>
              <li data-id="element-62">
                Seguir las instrucciones de higiene y seguridad indicadas en el
                libro
              </li>
              <li data-id="element-63">
                Consultar con un profesional de la salud ante cualquier duda
              </li>
            </ul>
          </section>

          <section data-id="element-64">
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-65">5. Resultados</h3>
            <p data-id="element-66">
              Los resultados de la elaboración de productos cosméticos
              artesanales pueden variar según los ingredientes utilizados, las
              condiciones de elaboración y el seguimiento de las instrucciones.
              No garantizamos resultados específicos.
            </p>
          </section>

          <section data-id="element-67">
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-68">
              6. Venta de Productos Artesanales
            </h3>
            <p data-id="element-69">
              Si decides comercializar productos elaborados con las fórmulas del
              eBook, eres responsable de cumplir con la normativa local vigente
              en materia de cosméticos, etiquetado, registro sanitario y
              cualquier otro requisito legal aplicable en tu país o región.
            </p>
          </section>

          <section data-id="element-70">
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-71">7. Precio y Pago</h3>
            <p data-id="element-72">
              El precio indicado en la página de venta es en dólares
              estadounidenses (USD). El procesamiento del pago se realiza a
              través de plataformas de pago seguras de terceros. La conversión
              de moneda, si aplica, se realiza al tipo de cambio vigente al
              momento de la transacción.
            </p>
          </section>

          <section data-id="element-73">
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-74">8. Modificaciones</h3>
            <p data-id="element-75">
              Nos reservamos el derecho de modificar estos términos y
              condiciones en cualquier momento. Las modificaciones entrarán en
              vigor a partir de su publicación en esta página.
            </p>
          </section>
        </div>
      </Modal>
    </>;
}